export default ['AMER', 'EMEA', 'APAC'];
